import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'
import { ClaimedPage } from './GetClaimedPage'

export class WithdrawnClaimPagesService {
  async getWithdrawnClaimPages(isAgency: boolean): Promise<ClaimedPage[]> {
    const api = new ScrubstrApiQueryService()

    const data = await api.get<ClaimedPage[]>({
      endpoint: 'admin/claim-pages/withdrawn-claimed-pages',
      params: { isAgency: String(isAgency) },
    })

    return Array.isArray(data) ? data.map((item) => ({ ...(item as any), type: isAgency ? 'agency' : 'hospital' })) : []
  }
}

